import React from 'react';

export const TitleBar = React.memo(({ pageContent, affiliationData }) => {
	return (
		<div className='row mx-0 mt-3 container-fluid'>
			<h1 className="titleBarHeading">
				{pageContent.headingPreText ? pageContent.headingPreText : ''}{' '}
				{affiliationData.name}{' '}
				{pageContent.headingPostText ? pageContent.headingPostText : ''}
			</h1>
		</div>
	);
});
